import { useMemo } from "react";
import { Navigate, To, useParams } from "react-router-dom";
import { skipToken } from "@reduxjs/toolkit/dist/query";
import { Editor } from "@/components";
import PageLoading from "@/components/page-loading/PageLoading";
import { useFetchOrganizationWebsiteQuery, useUpdateWebsiteMutation } from "@/features/organizations/api/websiteApi";
import useRoutes from "@/hooks/useRoutes";

type Params = {
  organizationId: string;
  websiteId: string;
};

const WebsiteEditor = () => {
  const [navigate, gerUrl] = useRoutes();
  const { organizationId, websiteId } = useParams<Params>();

  const websiteQuery = useFetchOrganizationWebsiteQuery(
    {
      organizationId: organizationId || skipToken,
      websiteId: websiteId || skipToken,
    },
    {
      skip: !organizationId || !websiteId,
    }
  );

  const [updateWebsite] = useUpdateWebsiteMutation();

  const onSave = async (data: string) => {
    if (!organizationId || !websiteId) return;

    await updateWebsite({
      organizationId,
      websiteId,
      website: {
        data,
      },
    });
  };

  const secondaryActions = useMemo(
    () => [
      {
        children: "Cambiar Plantilla",
        onClick: () => alert("To be defined"),
      },
      {
        children: "Reniciar Plantilla",
        onClick: () => alert("To be defined"),
      },
    ],
    []
  );

  if (websiteQuery.isLoading) {
    return <PageLoading />;
  }

  if (!organizationId || !websiteQuery?.data?.data) {
    return <Navigate to={gerUrl("organization.websites.main") as unknown as To} replace />;
  }

  return (
    <Editor
      title={websiteQuery.data.title}
      data={websiteQuery.data.data}
      onSave={onSave}
      actions={secondaryActions}
      onClose={() => navigate("organization.websites.main")}
      website={websiteQuery.data}
    />
  );
};

export default WebsiteEditor;
